import YFormInventoryChange from './InventoryChangeForm';

export { YFormInventoryChange };
export default YFormInventoryChange;
